export default __webpack_public_path__ + "static/media/card-w-press@2x.ac80406b.png";